<template>
    <v-container>
        <v-col>
            <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                    <v-card color="grey" flat height="100%" class="pa-3">
                        <v-card-title>Bereich 1: Grundlagen Sales 4.0</v-card-title>
                        <v-card-text>Im ersten Schritt geht es darum, eine gemeinsame Grundlage zu schaffen und wichtige
                            Begriffe zu erklären. Wie hat sich der Vertrieb in der Vergangenheit entwickelt? Wie sieht
                            der Vertrieb in Zukunft aus? Welche Vorteile hat die Digitalisierung des Vertriebs? Der
                            erste Bereich
                            umfasst folgende Ressourcen:
                        </v-card-text>
                        <div :class="{noselect: !auth, isDisabled: !auth}">
                            <v-card-title>Ressourcen</v-card-title>
                            <v-card-text>
                              <span v-if="auth">
                                <router-link to="/video" class="black--text">Video:</router-link> Herausforderungen im Prozess zum Sales 4.0
                              </span>
                                <span v-if="!auth">
                                <a href>Video:</a> Herausforderungen im Prozess zum Sales 4.0
                              </span>
                                <br/>
                                <span>
                                  <a :href="blog1" target="_blank">Blog:</a> Digitalisierung Vertrieb – Zukunft des B2B-Vertriebs
                                </span>
                                <br/>
                                <span>
                                <a :href="link1" target="_blank">PDF</a> zur Übersicht und Übertragung in die Praxis
                              </span>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                    <v-card color="grey" flat height="100%" class="pa-3">
                        <v-card-title>Bereich 2: technische Grundlagen schaffen</v-card-title>
                        <v-card-text>Im zweiten Schritt schaffen wir die technischen Grundlagen. In Unternehmen liegen
                            häufig viele unstrukturierte Daten vor. Diese gilt es zu organisieren und zu kanalisieren.
                            Dieser Bereich umfasst folgende Ressourcen:
                        </v-card-text>
                        <div :class="{noselect: !auth, isDisabled: !auth}">
                            <v-card-title>Ressourcen</v-card-title>
                            <v-card-text>
                                <span v-if="auth">
                                  <router-link to="/video1" class="black--text">Video:</router-link> Implementierung technischer Voraussetzungen
                                </span>
                                <span v-if="!auth">
                                  <a href>Video:</a> Implementierung technischer Voraussetzungen
                                </span>
                                <br/>
                                <span>
                                  <a :href="blog2" target="_blank">Blog:</a> Umsetzung Digitalisierung Vertrieb - Anwendungsbereiche gestalten
                                </span>
                                <br/>
                                <span>
                                  <a :href="link2" target="_blank">PDF</a> zur Übersicht und Übertragung in die Praxis
                                </span>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                    <v-card color="grey" flat height="100%" class="pa-3">
                        <v-card-title>Bereich 3: digitale Kompetenzen im Unternehmen</v-card-title>
                        <v-card-text>Digitalisierung ist häufig mit einer großen Ungewissheit für Mitarbeiter und
                            Mitarbeiterinnen verbunden. Transparenz ist somit von hoher Bedeutung. Die Fähigkeiten der
                            Mitarbeiter gilt es auszubauen, sodass Unternehmensziele erreichbar werden. Dieser Bereich
                            besteht aus folgenden Ressourcen:
                        </v-card-text>
                        <div :class="{noselect: !auth, isDisabled: !auth}">
                            <v-card-title>Ressourcen</v-card-title>
                            <v-card-text>
                                <span v-if="auth">
                                  <router-link to="/video2" class="black--text">Video:</router-link> praktische Vorgehensweise zur Förderung von Mitarbeitern
                                </span>
                                <span v-if="!auth">
                                  <a href>Video:</a> praktische Vorgehensweise zur Förderung von Mitarbeitern
                                </span>
                                <br/>
                                <span>
                                  <a :href="blog3" target="_blank">Blog:</a> Digitale Kompetenzen von Mitarbeitern entwickeln
                                </span>
                                <br/>
                                <span>
                                  <a :href="link3" target="_blank">PDF</a> zur Übersicht und Übertragung in die Praxis
                                </span>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                    <v-card color="grey" flat height="100%" class="pa-3">
                        <v-card-title>Bereich 4: Big Data im Vertrieb</v-card-title>
                        <v-card-text>Alle Voraussetzungen sind geschaffen. Die Grundlagen sind geklärt, technische
                            Unterstützungssysteme und Mitarbeiterfähigkeiten wurden gestärkt. Zeit, die neu gewonnenen
                            Daten richtig auszuwerten und zu nutzen. Viele Unternehmen wissen zwar um den Wert der
                            Informationen, ihnen fällt es jedoch schwer, Startpunkte beim Thema Sales 4.0 zu finden.
                            Dieser Bereich besteht aus folgenden Ressourcen:
                        </v-card-text>
                        <div :class="{noselect: !auth, isDisabled: !auth}">
                            <v-card-title>Ressourcen</v-card-title>
                            <v-card-text>
                                <span v-if="auth">
                                  <router-link to="/video3" class="black--text">Video:</router-link> Roadmap zur Implementierung von Big Data im Vertrieb
                                </span>
                                <span v-if="!auth">
                                  <a href>Video:</a> Roadmap zur Implementierung von Big Data im Vertrieb
                                </span>
                                <br/>
                                <span>
                                  <a :href="blog4" target="_blank">Blog:</a> Big Data im Vertrieb
                                </span>
                                <br/>
                                <span>
                                  <a :href="link4" target="_blank">PDF</a> zur Übersicht und Übertragung in die Praxis
                                </span>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" align="center" justify="center">
                    <div class="backgroundColor2 pa-6">
                        <strong
                                class="text-h5 font-weight-bold white--text"
                        >Whitepaper: Schritt für Schritt Anleitung zum Download</strong>
                        <div class="white--text">In 7 Schritten zur eigenen Umsetzung von <a class="sevensteps"
                                                                                             href="../static/sales_4.0.pdf"
                                                                                             target="_blank">Sales
                            4.0 →</a></div>
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-container>
</template>

<script>
    import firebase from "firebase";

    export default {
        data: () => ({
            link1: "",
            link2: "",
            link3: "",
            link4: "",
            blog1: "",
            blog2: "",
            blog3: "",
            blog4: "",
            auth: false,
        }),
        created() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.auth = true;
                    this.link1 = "./../static/thesenpapier_umsetzung_digitalisierung_vertieb-anwendungsbereiche_gestalten.pdf";
                    this.link2 = "./../static/thesenpapier_digitalisierung_vertrieb_zukunft_b2b_Vertrieb.pdf";
                    this.link3 = "./../static/thesenpapier_digitale_kompetenz_von_mitarbeitern_fördern.pdf";
                    this.link4 = "./../static/thesenpapier_big_data_im_vertrieb.pdf";
                    this.blog1 = "https://blog.enra.app/digitalisierung-vertrieb/";
                    this.blog2 = "";
                    this.blog3 = "";
                    this.blog4 = "";

                } else {
                    this.auth = false;
                    this.link1 = "";
                    this.link2 = "";
                    this.link3 = "";
                    this.link4 = "";
                    this.blog1 = "";
                    this.blog2 = "";
                    this.blog3 = "";
                    this.blog4 = "";


                }
            });
        },
    };
</script>

<style scoped>
    .sevensteps {
        color: white;
    }

    .backgroundColor2 {
        background-color: #e45364;
    }

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .isDisabled {
        color: currentColor;
        opacity: 0.5;
        text-decoration: none;
        pointer-events: none;
    }
</style>